module.exports = "<corporate-transportation-submission-page></corporate-transportation-submission-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/corporateTransportationSubmission.html
// module id = 2115
// module chunks = 0